import { ServiceEnv } from '@/utils/utils';
import {InjectionKey, Ref} from 'vue';

export const IsActiveEditDialog: InjectionKey< ()=>boolean > = Symbol('isActiveEditDialog');
export const CloseEditDialog: InjectionKey< ()=>void > = Symbol('closeEditDialog');
export const TestInjectionKey: InjectionKey<Ref<string>> = Symbol('TestInjectionKey');

export const IsActiveModuleEditDialog: InjectionKey< {id:string, isActive:boolean, schemaData:string, jsonData:string} > = Symbol('isActiveModuleEditDialog');
export const ServiceEnvKey: InjectionKey< ServiceEnv > = Symbol('serviceEnv');
export const IsAdmin: InjectionKey< boolean > = Symbol('isAdmin');
